/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Anna vähintään {minimumLength} merkkiä tai numeroa kaikkien lähteen {sourceName} tietueiden hakemiseksi.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Tuloksia ei löytynyt',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Tarkista tulokset toisista lähteistä tai vaihda avainsanaasi.',
  [HintsType.searching]: 'Haetaan…',
  companyTabTitle: 'Yritys',
  personalTabTitle: 'Henkilökohtainen',
  direct: 'Suora',
  extension: 'Alanro',
  contact: 'Yhteystieto',
  mobile: 'Mobiili',
  company: 'Yritys',
  home: 'Etusivu',
  home2: 'Etusivu',
  other: 'Muu',
  business: 'Työ',
  business2: 'Työ',
  car: 'Auto',
  fax: 'Faksi',
  assistant: 'Avustaja',
  callback: 'Takaisinsoitto',
  MobileNumber: 'Matkapuhelinnumero',
  ContactNumber: 'Yhteysnumero',
  DirectNumber: 'Suora numero',
  doNotCall: 'Älä soita',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
